import DATASTORE_TYPES from '@/components/shared/datastoreTypes';

const DISK_DATASTORES = [
  DATASTORE_TYPES.GCP_PD,
  DATASTORE_TYPES.AWS_EBS,
  DATASTORE_TYPES.AZ_MD,
];
export default DISK_DATASTORES;
